import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef } from '@opten/compiler/metadata/di';
import { ShopContext, accountService } from '../shop/shop-context';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { concatMap } from 'rxjs/operators';
import { User } from '../models/customer';
import { Renderer } from '@opten/renderer';
import { DefaultConverter } from '@opten/renderer/converters/default.converter';
import { IfConverter } from '@opten/renderer/converters/if.converter';
import { combineLatest } from 'rxjs';

@Component({ className: 'js-customer-area-auth', observe: true })
export class CustomerAreaAuth implements OnInit {
	@ComponentRef(ShopContext) shopContext: ShopContext;

	user: User;

	protected renderModel: {
		isGuest: boolean;
		hasAuth?: boolean;
	};

	private renderer: Renderer;

	constructor(private element: HTMLElement) {
		this.renderer = new Renderer([DefaultConverter, IfConverter]);
		this.renderModel = {
			isGuest: true
		};
		this.renderer.render(this.element, this.renderModel, this);
	}

	onInit(): void {
		combineLatest(this.shopContext.onAuthenticationChanged, this.shopContext.onIsGuest).subscribe(([user, isGuest]) => {
			this.renderModel.isGuest = isGuest;
			this.user = user;
			if (isGuest === false) {
				this.renderModel.hasAuth = this.checkIfHasAuth();
				if (this.renderModel.hasAuth) {
					accountService.get().subscribe(o => {
						if (this.element.getAttribute('data-redirect-url')) {
							window.location.assign(this.element.getAttribute('data-redirect-url'));
						}
					});
				}
			}
			this.renderer.render(this.element, this.renderModel, this);
		});
	}

	private checkIfHasAuth(): boolean {
		const auth = this.user.scope.authorizations.find(auth => auth.name === 'Website:CustomerArea');
		if (auth && auth.read) {
			return true;
		}
		return false;
	}
}
